// src/components/PrivateRoute.jsx
import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function PrivateRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug("[PrivateRoute]", { path: location.pathname, isLoading, isAuthenticated });
    }
  }, [location.pathname, isLoading, isAuthenticated]);

  if (isLoading) {
    return (
      <Box
        role="status"
        aria-live="polite"
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress color="info" />
      </Box>
    );
  }

  if (!isAuthenticated) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[PrivateRoute] not authenticated → /authentication/sign-in");
    }
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return <Outlet />;
}
